import React from 'react';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import Tooltip from '@material-ui/core/Tooltip';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import DescriptionIcon from '@material-ui/icons/Description';
import PictureInPictureIcon from '@material-ui/icons/PictureInPicture';
import IconButton from '@material-ui/core/IconButton';
//LOCAL IMPORTS
import { bytesToSize } from '../../Helpers/basic';
import { style } from '../../Styles/theme';
import { showSnackBar } from '../../Store/AlertMessages/actionCreator';
import AlertMessages from '../Shared/AlertMessages';
import TextEditor from '../Shared/TextEditor';
import { discussion_msgs } from '../Common/messages';
import { assignment_file_size, discussion_file_types } from "../../Configs/commonConfig";
import { createExternalDiscussion, updateExternalDiscussion } from '../../Store/Discussions/actionCreator';

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: '90px',
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      width: 'auto',
      paddingLeft: '50px',
      paddingRight: '50px',
      marginLeft: 'auto',
      marginRight: 'auto',
    }
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    marginTop: '-84px'
  },
  label: {
    marginTop: 15,
    fontSize: '1.5rem'
  },
  field: {
    marginTop: 30,
    backgroundColor: '#f5f5f5'
  },
  erromMsg: {
    color: 'red',
    marginBottom: '-10px'
  },
  dateWrapper: {
    marginLeft: '13px',
  },
  datePicker: {
    border: '1px solid',
    borderRadius: '5px',
    padding: '16px',
  },
  endDateWrapper: {
    border: '1px solid',
    borderRadius: '5px',
    padding: '16px',
  },
  titleWrapper: {
    fontSize: style.fontSize._heading,
    fontWeight: style.fontWeight._heading,
    color: style.fontColour._blue,
    marginBottom: '11px'
  },
  searchBoxOutline: {
    borderWidth: "1px",
    borderColor: "#2e8eec !important"
  },
  button: {
    flexGrow: 1,
    textTransform: 'none',
    marginRight: '10px',
    backgroundColor: style.fontColour._blue,
    color: '#FFFFFF',
    '&:hover': {
      backgroundColor: style.fontColour._blue,
    },
  },
  uploadLabel: {
    marginTop: '5px'
  },
  uploadIcon: {
    color: style.fontColour._blue,
    width: 30,
    height: 30,
    verticalAlign: 'bottom',
    cursor: 'pointer'
  },
  uploadedAttachement: {
    width: 62,
    marginLeft: 20,
    color: 'blue',
    border: '2px solid #ccc',
    cursor: 'pointer'
  },
  errorMsg: {
    color: 'red',
    marginBottom: '-10px'
  },
  uploadedFileWrapper: {
    textDecoration: 'none',
    marginLeft: '10px',
    border: '2px solid #ccc',
  },
  readingsButton: {
    float: 'right',
    marginBottom: '5px',
    marginLeft: '10px',
    color: '#3f51b5'
  },
  helpertext: {
    lineHeight: '6%',
    marginLeft: '-8px',
    fontSize: '11px',
    fontWeight: 500
  },
}))

function AddDiscussion(props) {
  const classes = useStyles();
  const [inProgress, setInProgress] = React.useState(false)

  const defaultTitle = props.discussionDetails && props.discussionDetails.title ? props.discussionDetails.title : ''
  const [discussionTitle, setDiscussionTitle] = React.useState(defaultTitle)

  const defaultDesc = props.discussionDetails && props.discussionDetails.description ? props.discussionDetails.description : ''
  const [discussionDesc, setDiscussionDesc] = React.useState(defaultDesc)

  const defaultThread = props.discussionDetails && props.discussionDetails.threaded_reply ? props.discussionDetails.threaded_reply : false
  const defaultCanseeBefore = props.discussionDetails && props.discussionDetails.preview_reply ? props.discussionDetails.preview_reply : false
  const [selectedOptions, setSelectedOptions] = React.useState({
    allowThread: defaultThread,
    canseeBeforeReply: defaultCanseeBefore,
  });
  const [attachmentFileDetails, setAttachmentFileDetails] = React.useState({});
  const defaultFile = props.discussionDetails && props.discussionDetails.attachment ? props.discussionDetails.attachment : null
  const [uploadedAttachmentPreview, setUploadedAttachmentPreview] = React.useState(defaultFile)

  const values = {
    discussion_id: props.discussionDetails && props.discussionDetails.id ? props.discussionDetails.id : '',
    discussionTitle: props.discussionDetails && props.discussionDetails.title ? props.discussionDetails.title : '',
    discussionDesc: props.discussionDetails && props.discussionDetails.description ? props.discussionDetails.description : '',
    attachment: props.discussionDetails && props.discussionDetails.attachment ? props.discussionDetails.attachment : null
  }
  const [validationError, setValidationError] = React.useState({
    error: false,
    errorMessage: ''
  })
  const [formFieldStatus, setFormFieldStatus] = React.useState(
    {
      discussionTitle: {
        error: false
      },
      discussionDesc: {
        error: false
      }
    }
  );

  const handleChangeTitle = evnt => {
    setDiscussionTitle(evnt.target.value)
  }
  const onChangeEditorContent = data => {
    setDiscussionDesc(data)
  }
  const handleChangeOptions = (event) => {
    setSelectedOptions({ ...selectedOptions, [event.target.name]: event.target.checked });
  };

  //atttchment uploads
  const onFileToUploadClick = type => {
    document.getElementById(type).click()
  }

  const validatedFile = type => {
    const selectedFile = document.getElementById(type).files
    let fileDetails = {
      fileError: false,
      fileErrorErrorMessage: ''
    }
    if (!selectedFile.length || selectedFile.length > 1) {
      fileDetails = {
        fileError: false,
        fileErrorErrorMessage: ''
      }
    } else {
      const file = selectedFile[0]
      if (type === 'attachmentfile' && file.size > assignment_file_size) {
        fileDetails = {
          fileError: true,
          fileErrorErrorMessage: 'File size should be less than 10MB'
        }
      } else {
        const fileFormats = () => {
          if (type === 'attachmentfile') {
            return discussion_file_types
          }
        }
        const allowedExtensions = fileFormats()
        const currentExtension = file.name.split('.')[1].toLowerCase()
        if (allowedExtensions.indexOf(currentExtension) === -1) {
          fileDetails = {
            fileError: true,
            fileErrorErrorMessage: 'Invalid File Format'
          }
        } else {
          fileDetails = {
            fileError: false,
            fileErrorErrorMessage: '',
            name: file.name,
            size: bytesToSize(file.size),
            type: file.type,
            file: file
          }
        }
      }
    }
    return fileDetails
  }

  const onAttachmentUpload = event => {
    const attachment = validatedFile('attachmentfile')
    setAttachmentFileDetails(attachment)
    setUploadedAttachmentPreview(event.target.files[0] ? URL.createObjectURL(event.target.files[0]) : null)
  }

  const closeTrigger = () => {
    props.cancelAddDiscussion()
  }

  const successUpdateDiscussion = res => {
    setInProgress(false)
    props.showSnackBar({
      state: true,
      message: discussion_msgs.SUCCESS_DISCUSSION_UPDATE,
      type: 'success'
    })
    props.cancelAddDiscussion()
    props.listAllDiscussions()
  }

  const failureUpdateDiscussion = error => {
    setInProgress(false)
    props.showSnackBar({
      state: false,
      message: discussion_msgs.ERROR_UPDATE_DISCUSSION,
      type: 'error'
    })
  }

  const succsessCreateDisccussion = res => {
    setInProgress(false)
    props.showSnackBar({
      state: true,
      message: discussion_msgs.SUCCESS_DISCUSSION_CREATE,
      type: 'success'
    })
    props.cancelAddDiscussion()
    props.listAllDiscussions()
    props.fetchTabCounts()
  }

  const failureCreateDiscussion = error => {
    setInProgress(false)
    props.showSnackBar({
      state: false,
      message: discussion_msgs.ERROR_CREATE_DISCUSSION,
      type: 'error'
    })
  }

  const initiateDiscussion = event => {
    event.preventDefault()
    if (!discussionTitle) {
      setFormFieldStatus({
        discussionTitle: {
          error: true
        },
        discussionDesc: {
          error: false
        }
      })
      setValidationError({
        error: true,
        errorMessage: 'Please Add Topic Title!'
      })
    }
    else if (!discussionDesc) {
      setFormFieldStatus({
        discussionTitle: {
          error: false
        },
        discussionDesc: {
          error: true
        },
        discussionPoints: {
          error: false
        }
      })
      setValidationError({
        error: true,
        errorMessage: 'Please Add Topic Description!'
      })
    } else {
      setFormFieldStatus({
        discussionTitle: {
          error: false
        },
        discussionDesc: {
          error: false
        }
      })
      setValidationError({
        error: false,
        errorMessage: ''
      })
      setInProgress(true)
      if (props.discussionDetails) {
        const payload = {
          discussion_id: props && props.discussionDetails && props.discussionDetails.id
        }
        let formData = new FormData()
        formData.append('discussion_id', props && props.discussionDetails && props.discussionDetails.id)
        formData.append('title', discussionTitle ? discussionTitle : '')
        formData.append('description', discussionDesc ? discussionDesc : '')
        formData.append('threaded_reply', selectedOptions.allowThread)
        formData.append('preview_reply', selectedOptions.canseeBeforeReply)
        formData.append('attachment', attachmentFileDetails.file ? attachmentFileDetails.file : null)
        updateExternalDiscussion(payload, formData, successUpdateDiscussion, failureUpdateDiscussion)
      } else {
        let formData = new FormData()
        formData.append('title', discussionTitle ? discussionTitle : '')
        formData.append('description', discussionDesc ? discussionDesc : '')
        formData.append('threaded_reply', selectedOptions.allowThread)
        formData.append('preview_reply', selectedOptions.canseeBeforeReply)
        formData.append('attachment', attachmentFileDetails.file ? attachmentFileDetails.file : null)
        createExternalDiscussion(formData, succsessCreateDisccussion, failureCreateDiscussion)
      }
    }
  }

  return (
    <div className={classes.root}>
      <div id="mainH1Tag" tabIndex="-1" className="accessibility">
        <h1>{props.discussionDetails ? 'Update discussion form' : 'Add Discussion form'}</h1>
      </div>
      <Grid container>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Paper className={classes.paper}>
            <Typography className={classes.titleWrapper} aria-hidden="true">{props && props.discussionDetails ? 'Edit Discussion' : 'Add Discussion'}</Typography>
            {validationError.error ? (
              <div style={{ width: '42%', marginBottom: '18px', display: 'inline-block' }}>
                <AlertMessages status="error" message={validationError.errorMessage} />
              </div>
            ) : null}
            <form noValidate autoComplete="off" onSubmit={initiateDiscussion} >
              <TextField
                id="title"
                placeholder="Topic title"
                helperText="max: 100 chars"
                required
                variant="outlined"
                error={formFieldStatus.discussionTitle.error}
                defaultValue={values.discussionTitle}
                inputProps={{
                  maxLength: 100,
                }}
                InputProps={{
                  classes: {
                    notchedOutline: !formFieldStatus.discussionTitle.error ? classes.searchBoxOutline : ''
                  }
                }}
                autoFocus={true}
                style={{
                  width: '100%'
                }}
                onChange={handleChangeTitle}
              />
              <div style={{ marginTop: '20px', marginBottom: '20px' }}>
                <Typography style={{ textAlign: 'initial', fontSize: 'inherit', fontWeight: '300', marginLeft: '3px', marginBottom: '3px' }}>
                  About this Discussion
                  <span className="MuiFormLabel-asterisk MuiInputLabel-asterisk">&thinsp;*</span>
                </Typography>
                <TextEditor onChangeEditorContent={onChangeEditorContent} helperText={'About discussion'} description={discussionDesc} />
              </div>

              <Grid container spacing={2}>

                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  {attachmentFileDetails.fileError ? (
                    <Typography variant="caption" display="block" gutterBottom className={classes.errorMsg}>
                      {attachmentFileDetails.fileErrorErrorMessage}
                    </Typography>
                  ) : null}
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={3} lg={3}>
                      <div style={{ display: 'flex', marginTop: '5px' }}>
                        <span className={classes.uploadLabel} aria-hidden="true">
                          Upload Attachment
                      </span>
                        <IconButton style={{ padding: '2px 8px' }} aria-label="upload attachment" onClick={() => { onFileToUploadClick('attachmentfile') }}>
                          <CloudUploadIcon className={classes.uploadIcon} />
                        </IconButton>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={9} lg={9}>
                      <div style={{ display: 'flex', marginTop: '12px' }}>
                        <span className={classes.helperText}>(max.size: 10MB, format: pdf, docx, ppt)</span>
                        {attachmentFileDetails.file && attachmentFileDetails.file.name && uploadedAttachmentPreview ? (
                          <a href={uploadedAttachmentPreview} target='_blank' className={classes.uploadedFileWrapper}>
                            { attachmentFileDetails.file.name.length > 25 ? (
                              attachmentFileDetails.file.name.substr(0, 20) + '....'
                            ) :
                              attachmentFileDetails.file.name
                            }
                          </a>
                        ) : (
                          <React.Fragment>
                            { props.discussionDetails && values.attachment ? (
                              <React.Fragment>
                                <Tooltip title="Attachment">
                                  <a href={values.attachment} target='_blank' edge="start" color="primary" className={classes.readingsButton} aria-label="close">
                                    {values.attachment.split('?')[0].split(/\.(?=[^\.]+$)/)[1] === 'pdf' ? <PictureAsPdfIcon style={{ color: '#2e8eec' }} /> : values.attachment.split('?')[0].split(/\.(?=[^\.]+$)/)[1] === 'ppt' ? <PictureInPictureIcon style={{ color: '#2e8eec' }} /> : <DescriptionIcon style={{ color: '#2e8eec' }} />}
                                  </a>
                                </Tooltip>
                              </React.Fragment>
                            ) : null}
                          </React.Fragment>
                        )}
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
                <input type="file" accept=".ppt,.pdf,.docx" style={{ display: 'none' }} id="attachmentfile" onChange={onAttachmentUpload} />
              </Grid>
              <div style={{ marginTop: '33px', marginBottom: '20px', textAlign: 'initial' }}>
                <Typography style={{ textAlign: 'initial', fontSize: '16px', marginLeft: '3px', marginBottom: '3px' }}>
                  Options
                </Typography>
                <List>
                  <ListItem>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={selectedOptions.allowThread}
                          onChange={handleChangeOptions}
                          name="allowThread"
                          style={{ color: '#2e8eec' }}
                        />
                      }
                      label="Allow threaded replies"
                    />
                  </ListItem>
                  <ListItem>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={selectedOptions.canseeBeforeReply}
                          onChange={handleChangeOptions}
                          name="canseeBeforeReply"
                          style={{ color: '#2e8eec' }}
                        />
                      }
                      label="Users must post before seeing replies"
                    />
                  </ListItem>
                </List>
              </div>

              <Button variant="contained" className={classes.button} onClick={initiateDiscussion} disabled={inProgress}>
                {inProgress ? (
                  <CircularProgress size={30} style={{ marginRight: 10, color: '#2e8eec' }} />
                ) : null}
                {props.discussionDetails ? 'Update Discussion' : 'Create Discussion'}
              </Button>
              <Button variant="contained" style={{ textTransform: 'none' }} disabled={inProgress} onClick={closeTrigger}>Cancel</Button>
            </form>
          </Paper>
        </Grid>
      </Grid>
    </div>
  )
}

const mapStateToProps = state => {
  return {}
}

export default connect(
  mapStateToProps, { showSnackBar }
)(AddDiscussion);